import React, { useEffect, useState } from "react";
import Editor from "../../../elements/tiptap-editor/Editor";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { postAddEdit } from "../../../../services/postService";
import { useMutation } from "@tanstack/react-query";
import Input from "../../../form/Input";
import { toast } from "react-toastify";
import { taxonomyList } from "../../../../services/taxonomyService";
import { generateSlug, supportedLanguages, userLang } from "../../../../helpers";
import LanguageTabs from "../../../elements/LanguageSwitcher";

const validation = {
  title: { required: true, message: "Title is required" },
  // content: { required: true, message: "Content is required" },
};

const ManageHowItWorks = ({ getResponse = () => {}, close = () => {}, data }) => {
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });
  const [currentLang, setCurrentLang] = useState(userLang || "en");
  const handleLangChange = (lang) => {
    setCurrentLang(lang);
  };

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        content: {
          ...supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = {
              title: data?.content?.[lang.code]?.title || "",
              subTitle: data?.content?.[lang.code]?.subTitle || "",
              content: data?.content?.[lang.code]?.content || "",
              seo: data?.content?.[lang.code]?.seo || {},
            };
            return acc;
          }, {}),
        },
        title: data?.content?.[currentLang]?.title || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const {
    mutate,
    error,
    isLoading: detailsLoading,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        type: "how-it-works",
        slug: `${generateSlug(val?.content?.[userLang]?.title.replace(/\s+/g, "-").toLowerCase(), Date.now())}`,
        lang: localStorage.getItem("lang"),
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <LanguageTabs languages={supportedLanguages} value={currentLang} onChange={handleLangChange} />
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-4">
          <Input
            label="Title"
            inputPlaceholder="title"
            inputName={`content.${currentLang}.title`}
            value={values?.content?.[currentLang]?.title || ""}
            onChange={(e) => {
              const newValue = e.target.value;
              setFieldsValue({
                ...values,
                title: newValue,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    title: newValue,
                  },
                },
              });
            }}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="Content"
            placeholder="content"
            value={values?.content?.[currentLang]?.content || ""}
            onChange={(val) => {
              setFieldsValue({
                ...values,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    content: val,
                  },
                },
              });
            }}
            // {...formValidate(errors, "content")}
          />
        </div>

        {/* <div className="flex items-start gap-4">
          <Input
            label={"InActive"}
            inputPlaceholder={"Enter"}
            inputName="inActive"
            value={values?.inActive}
            onChange={handleChange}
            {...formValidate(errors, "inActive")}
          />
          <div className="w-full"></div>
        </div> */}
      </div>
      <div className="pt-3 p-6 flex justify-end">
        <Button
          buttonType="submit"
          buttonClasses={"min-w-36"}
          buttonLabel={data?._id ? "Update" : "Save"}
          {...((isLoading || detailsLoading) && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </form>
  );
};

export default ManageHowItWorks;
